export const getDialog = ({ dialog: moduleState }, dialogID) => moduleState
  .dialogs[dialogID] || {};

export const getGraph = ({ dialog: moduleState }, dialogID) => {
  const { dialogs } = moduleState;
  const { graph } = dialogs[dialogID] || {};
  return graph || {};
};

export const getNodes = ({ dialog: moduleState }, dialogID) => {
  const { dialogs } = moduleState;
  const { graph } = dialogs[dialogID] || {};
  const { nodes } = graph || {};
  return nodes || [];
};

export const getEdges = ({ dialog: moduleState }, dialogID) => {
  const { dialogs } = moduleState;
  const { graph } = dialogs[dialogID] || {};
  const { edges } = graph || {};
  return edges || [];
};

export const getFeature = ({ dialog: moduleState }, dialogID, featureID) => {
  const { dialogs } = moduleState;
  const { graph } = dialogs[dialogID] || {};
  const { nodes } = graph || {};
  const result = (nodes || []).find((n) => n.data.featureID === featureID);
  return result ? result.data : {};
};

export const getFeatures = ({ dialog: moduleState }, dialogID) => {
  const { dialogs } = moduleState;
  const { graph } = dialogs[dialogID] || {};
  const { nodes } = graph || {};
  return (nodes || []).map((n) => n.data);
};

export const getValidationGraph = ({ dialog: moduleState }, dialogID) => {
  const { validationGraphs } = moduleState;
  return validationGraphs[dialogID] || {};
};

export const getValidationGraphError = ({ dialog: moduleState }, dialogID, nodeID) => {
  const { isValid, errors } = getValidationGraph({ dialog: moduleState }, dialogID);

  if (isValid) return { isValid: true };

  const result = (errors || []).find((validationError) => {
    const { source: { currentNode } } = validationError;
    const { id } = currentNode || {};
    return id === nodeID;
  });
  return {
    isValid: !result,
    error: result,
  };
};
